//REGISTER
export const POST_FAKE_REGISTER = "/auth/register"

//LOGIN
export const POST_FAKE_LOGIN = "/auth/login"
export const POST_FAKE_JWT_LOGIN = "/auth/login"
export const POST_FAKE_PASSWORD_FORGET = "/auth/forgot-password"
export const POST_FAKE_JWT_PASSWORD_FORGET = "/auth/forgot-password"
export const SOCIAL_LOGIN = "/auth/social-login"

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"

//PRODUCTS
export const GET_PRODUCTS = "/products"
export const GET_PRODUCTS_DETAIL = "/product"

//CALENDER
export const GET_EVENTS = "/events"
export const ADD_NEW_EVENT = "/add/event"
export const UPDATE_EVENT = "/update/event"
export const DELETE_EVENT = "/delete/event"
export const GET_CATEGORIES = "/categories"

//CHATS
export const GET_CHATS = "/chat/recent";
export const GET_GROUPS = "/groups"; // Keeping for groups if needed later
export const GET_CONTACTS = "/chat/contacts";
export const GET_MESSAGES = "/chat";
export const ADD_MESSAGE = "/chat";
export const MARK_READ = "/chat/mark-read";
export const DELETE_MESSAGE = "/chat";

//TASKS
export const GET_TASKS = "/tasks";
export const DELETE_KANBAN = "/delete/tasks"
export const ADD_CARD_DATA = "/add/tasks"
export const UPDATE_CARD_DATA = "/update/tasks"

//COMPANIES (Admin)
export const GET_COMPANIES = "/admin/companies"
export const GET_COMPANY_DETAIL = "/admin/companies"
export const UPDATE_COMPANY = "/admin/companies"
export const DELETE_COMPANY = "/admin/companies"
export const TOGGLE_COMPANY_STATUS = "/admin/companies" // + /{id}/toggle-status

//SUBSCRIPTION PLANS (Admin)
export const GET_PLANS = "/admin/plans"
export const ADD_PLAN = "/admin/plans"
export const UPDATE_PLAN = "/admin/plans"
export const DELETE_PLAN = "/admin/plans"

//CUSTOMERS (Company)
export const GET_CUSTOMERS = "/customers"
export const ADD_CUSTOMER = "/customers"
export const UPDATE_CUSTOMER = "/customers"
export const DELETE_CUSTOMER = "/customers"
export const EXPORT_CUSTOMERS = "/customers-export"
export const GET_COMPANY_USERS = "/users"
export const GET_COMPANY_ROLES = "/roles"
export const GET_COMPANY_DASHBOARD_STATS = "/dashboard/stats"

// Admin - Subscription Management
export const ADMIN_SUBSCRIPTIONS_PENDING = "/admin/subscriptions/pending"
export const ADMIN_SUBSCRIPTIONS_ALL = "/admin/subscriptions"
export const ADMIN_SUBSCRIPTIONS_STATS = "/admin/subscriptions/statistics"
export const ADMIN_SUBSCRIPTION_VALIDATE = "/admin/subscriptions"

// Suppliers
export const SUPPLIERS = "/suppliers"
export const SUPPLIER_INVOICES = "/supplier-invoices"

// CRM Sub-resources
export const INTERACTIONS = "/interactions"
export const DOCUMENTS = "/documents"
export const CUSTOM_FIELDS = "/custom-fields"
export const CUSTOMER_CATEGORIES = "/customer-categories"

// Billing
export const QUOTES = "/quotes"
export const INVOICES = "/invoices"
export const PAYMENTS = "/payments"

// Products & Services
export const PRODUCTS = "/products"

// SYSTEM USERS (Super Admin)
export const GET_SYSTEM_USERS = "/admin/system-users"

// ROLES & PERMISSIONS (Super Admin)
export const GET_ROLES = "/admin/roles"
export const GET_PERMISSIONS_GROUPED = "/admin/permissions-grouped"
export const PERMISSIONS = "/admin/permissions"

// DASHBOARD (Super Admin)
export const GET_ADMIN_DASHBOARD_STATS = "/admin/dashboard/stats";
export const GET_SALES_STATS = "/admin/dashboard/sales/stats";
export const GET_ADMIN_INVOICES = "/admin/invoices";

// SETTINGS (Super Admin)
export const GET_SYSTEM_SETTINGS = "/admin/settings"
export const UPDATE_SYSTEM_SETTINGS_BULK = "/admin/settings/bulk"

// Tickets
export const TICKETS = "/tickets";

// Admin Tickets
export const GET_ADMIN_TICKETS = "/admin/tickets";
export const TICKETS_REPLY = "/admin/tickets";

// Notifications
export const GET_NOTIFICATIONS = "/notifications"
